import React from "react";
import { List } from "antd";

import CustomTag from "components/ui/CustomTag";

const AlphaList = ({ list, toggleTag }) => {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  let listItems = {};

  alphabet.forEach(letter => {
    list.forEach(item => {
      if (item.name.toUpperCase().startsWith(letter, 0)) {
        if (!(letter in listItems)) {
          listItems[letter] = [item];
        } else {
          listItems[letter].push(item);
        }
      }
    });
    if (listItems[letter])
      listItems[letter].sort((a, b) => (a.name < b.name ? -1 : 1));
  });

  return (
    <List
      itemLayout="horizontal"
      dataSource={Object.keys(listItems)}
      renderItem={letter => (
        <List.Item>
          <span>
            <h3 className="title" style={{ marginRight: 10 }}>
              {letter}
            </h3>
            {listItems[letter].map(item => (
              <CustomTag
                key={item.attribute_id}
                onChange={() => toggleTag(item.attribute_id)}
                checked={item.selected}
              >
                {item.name}
              </CustomTag>
            ))}
          </span>
        </List.Item>
      )}
    />
  );
};

export default AlphaList;
